import { ServiceCenter } from '../../../shared/models/service-center';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FacadeService } from 'src/app/core/services/facade.service';
import { LogService } from 'src/app/core/services/log/log.service';
import { User } from 'src/app/shared/models/security/user';
import {
	AbstractControl,
	FormControl,
	FormGroup,
	Validators
} from '@angular/forms';
import { PasswordMatchValidator } from 'src/app/shared/utils/password-match-validator';

@Component({
	selector: 'app-change-password',
	templateUrl: './change-password.component.html',
	styleUrls: ['./change-password.component.scss']
})
export class ChangePasswordComponent implements OnInit {
	successfulChange = false;
	unsuccessfulChange = false;
	user: User = null;

	changePasswordForm = new FormGroup(
		{
			currentPassword: new FormControl('', [
				Validators.required,
			]),
			newPassword: new FormControl('', [
				Validators.required,
				Validators.minLength(8),
				Validators.pattern(
					`^(?=.*\\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z]).{8,}$`
				)
			]),
			newPasswordRepeated: new FormControl('', [
				Validators.required,
				Validators.minLength(8),
				Validators.pattern(
					`^(?=.*\\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z]).{8,}$`
				)
			])
		},
		{ validators: this.passwordMatchValidator.validate }
	);

	constructor(
		private router: Router,
		private logger: LogService,
		private facade: FacadeService,
		private passwordMatchValidator: PasswordMatchValidator
	) {}

	ngOnInit(): void {
		this.user = this.facade.dataStorageService.getUser();
		console.log(this.facade.dataStorageService.isIntervenant());
	}

	changePassword(): void {
		const user: User = this.facade.dataStorageService.getUser();
		user.password = this.changePasswordForm.get('newPassword').value;
		user.motDePasseGenere = this.changePasswordForm.get('currentPassword').value;
		// user.previousPassword =
		// 	this.changePasswordForm.get('currentPassword').value;
		if(this.facade.dataStorageService.isIntervenant()){
			this.facade.employeeService.changePassword(user).subscribe({
				next: (succ) => {
					this.successfulChange = true;
					// if (user.firstLogin) {
					// 	this.clearStorage();
					// 	this.router.navigate(['/login']);
					// }
				},
				error: (err) => {
					this.unsuccessfulChange = true;
					this.facade.toastService.createHttpErrorToast(
						err.error.message ? err.error.message : '',
						err.status
					);
					this.logger.log(
						'' + err.status + ' ' + err.error.message ? err.error.message : ''
					);
				}
			});
		}else{
			this.facade.userService.changePassword(user).subscribe({
				next: (succ) => {
					this.successfulChange = true;
					// if (user.firstLogin) {
					// 	this.clearStorage();
					// 	this.router.navigate(['/login']);
					// }
				},
				error: (err) => {
					this.unsuccessfulChange = true;
					this.facade.toastService.createHttpErrorToast(
						err.error.message ? err.error.message : '',
						err.status
					);
					this.logger.log(
						'' + err.status + ' ' + err.error.message ? err.error.message : ''
					);
				}
			});
		}
	}

	closeAlerts(): void {
		this.successfulChange = false;
		this.unsuccessfulChange = false;
	}

	clearStorage() {
		this.facade.dataStorageService.clearStorage();
	}

	// Helper method to determince the form has any errors
	isFormError() {
		const { errors } = this.changePasswordForm;
		const passwordTouched = this.changePasswordForm.get('newPassword').touched;
		const confirmPasswordTouched = this.changePasswordForm.get(
			'newPasswordRepeated'
		).touched;
		return errors && passwordTouched && confirmPasswordTouched;
	}

	convertToFormControl(absCtrl: AbstractControl | null): FormControl {
		const ctrl = absCtrl as FormControl;
		return ctrl;
	}
}
